import React, {SyntheticEvent} from 'react';

import GDDateRangePicker from '../../gd-components/datetime/gd-daterange-picker/daterange-picker';
import FormManager from "../../gd-form/common/form-manager";
import Moment from "moment";
import {momentRange} from "../../gd/convert/moment-range";

type Props = {
    className?              : string
    value?                  : any // MomentRange | Moment  Ochen' stranno sdelano. No eto kak-to rabotaet. Current date range value moment object

    dateRangePresets?       : any[]
    dateFormat?             : string
    renderValue?            : 'inline' | 'text-14' | 'text-normal' | 'text-13' | 'text-12' | 'text-11' | 'inline-icon' | 'form-default'
    type?                   : 'default' | 'form' | 'inline' | 'list'
    size?                   : "small" | "normal" | "big"

    minDate?                : Moment
    maxDate?                : Moment
    minDaysRange?           : number | null

    btnNoValue?             : boolean
    btnNoValueLabel?        : string

    placeholder             : string
    hint?                   : string
    underlined?             : 'on-hover' | 'always' | 'never'

    popoverAttachment       : string
    popoverTargetAttachment : string
    popoverTargetOffset?    : string
    attachmentType?         : any
    tetherConstraints?      : any[]        // PropTypes.array,
    disabled?               : boolean

    // form - if passed component will act as form element
    form?                   : FormManager
    startName?              : string
    endName?                : string

    deleteButton            : boolean      // if true will show delte button to reset date to null

    onTogglePopover?        : func
    onChange                : func         // on change callback
}

export default class SelectStartEnd extends React.Component<Props, any> {

    static defaultProps = {
        type            : 'default',
        deleteButton    : false,
        placeholder     : 'Start/End'
    };

    public gdDateRangePicker: GDDateRangePicker | null = null;

    constructor(props: Props) {
        super(props);

        this.state = {
            start: props.form ? props.form.getValue(props.startName!) : props.value ? props.value.start : null,
            end: props.form ? props.form.getValue(props.endName!) : props.value ? props.value.end : null,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        // const { value, form, startName, endName} = nextProps;

        // when form value changed and we re-render the whole thing
        this.setState({
            start: nextProps.form ? nextProps.form.getValue(nextProps.startName!) : nextProps.value ? nextProps.value.start : null,
            end: nextProps.form ? nextProps.form.getValue(nextProps.endName!) : nextProps.value ? nextProps.value.end : null,
        });
    }

    UNSAFE_componentWillMount() {
        if (this.props.form) this.props.form.registerFormComponent(this.props.startName!, this);
    }

    setValue = (dateRange: MomentRange) => {
        this.setState({
            start: dateRange.start,
            end: dateRange.end
        });
    };

    //for reference call from outside
    onClick = () => {
        if(this.props.disabled) return;

        if (!!this.gdDateRangePicker) {
            this.gdDateRangePicker.togglePopover();
        }
    };

    onChange = (dateRange: MomentRange | null)=> {
        if (dateRange && this.props.minDaysRange) {
            const daysInRange = dateRange.end.diff(dateRange.start, 'days') + 1;
            if (daysInRange < this.props.minDaysRange) {
                dateRange = momentRange(
                    Moment(dateRange.start),
                    Moment(dateRange.start).add(this.props.minDaysRange, 'days')
                );
            }
        }

        this.setState({
            start: dateRange ? dateRange.start : null,
            end: dateRange ? dateRange.end : null
        }, ()=>{
            if (this.props.form) this.props.form.onFormComponentValueChange(this.props.startName!, dateRange ? dateRange.start.format("YYYY-MM-DD") : null);
            if (this.props.form) this.props.form.onFormComponentValueChange(this.props.endName!, dateRange ? dateRange.end.format("YYYY-MM-DD") : null);
            if (this.props.onChange) this.props.onChange(dateRange);
        });
    }

    onDeleteClick = (e: SyntheticEvent)=> {
        if (e) e.stopPropagation();
        this.onChange(null);
    }

    render() {
        const empty = !this.state.start || !this.state.end;
        const classes = Classes('gd-select-start-end', 'render-'+this.props.renderValue, this.props.type+'-type', this.props.className, {
            'with-delete-button': this.props.deleteButton,
            disabled: this.props.disabled,
            empty: empty
        });

        const value = this.state.start && this.state.end ? momentRange(Moment(this.state.start), Moment(this.state.end)) : null;

        const dateFormat = this.props.dateFormat ? this.props.dateFormat : gd.session.me.formatSettings.date;

        return (
            <div className={classes} onClick={this.onClick}>
                <GDDateRangePicker ref                      = {r=>this.gdDateRangePicker = r}
                                   type                     = {this.props.renderValue}
                                   size                     = {this.props.size}
                                   disabled                 = {this.props.disabled}
                                   underlined               = {this.props.underlined}
                                   placeholder              = {this.props.placeholder}
                                   popoverTargetAttachment  = {this.props.popoverTargetAttachment}
                                   popoverAttachment        = {this.props.popoverAttachment}
                                   popoverTargetOffset      = {this.props.popoverTargetOffset}
                                   tetherConstraints        = {this.props.tetherConstraints}
                                   attachmentType           = {this.props.attachmentType}
                                   presets                  = {this.props.dateRangePresets}
                                   dateFormat               = {dateFormat}
                                   noIcon                   = {this.props.renderValue !== 'inline'}
                                   value                    = {value}
                                   minDate                  = {this.props.minDate}
                                   maxDate                  = {this.props.maxDate}
                                   btnNoValue               = {this.props.btnNoValue}
                                   btnNoValueLabel          = {this.props.btnNoValueLabel}
                                   hint                     = {this.props.hint}
                                   onUserSelect             = {this.onChange}
                                   onTogglePopover          = {this.props.onTogglePopover}/>

                {this.props.deleteButton && !this.props.disabled && !empty &&
                    <div className="reset-button" onClick={this.onDeleteClick}>
                        <div className="reset-icon i5-delete-circle-solid s14 gray"/>
                    </div>}
            </div>
        );
    }
}
